'use strict';

var index = require('../define-properties/index.js');
var implementation$1 = require('./implementation.js');
var polyfill$1 = require('./polyfill.js');
var shim$1 = require('./shim.js');

var define = index;

var implementation = implementation$1;
var getPolyfill = polyfill$1;
var polyfill = getPolyfill();
var shim = shim$1;

var boundContains = function contains(node, other) {
	return polyfill.apply(node, [other]);
};

define(boundContains, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

var document_contains = boundContains;

module.exports = document_contains;
